import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class UiService implements OnDestroy {
	private readonly unsubscribe$ = new Subject();

	constructor(private breakpointObserver: BreakpointObserver) {
		this.unsubscribe$ = new Subject();
	}

	onDetectScreen(size: number): Observable<boolean> {
		return this.breakpointObserver
			.observe('(max-width:' + size + 'px)')
			.pipe(map((result) => result.matches));
	}

	onDetectSmallDevices(): Observable<boolean> {
		return this.breakpointObserver
			.observe('(max-width: 600px)')
			.pipe(map((result) => result.matches));
	}

	onDetectMediumDevices(): Observable<boolean> {
		return this.breakpointObserver
			.observe('(max-width: 768px)')
			.pipe(map((result) => result.matches));
	}

	onDetectLargeDevices(): Observable<boolean> {
		return this.breakpointObserver
			.observe('(max-width: 992px)')
			.pipe(map((result) => result.matches));
	}

	onDetectExtraLargeDevices(): Observable<boolean> {
		return this.breakpointObserver
			.observe('(max-width: 1200px)')
			.pipe(map((result) => result.matches));
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}
}
